export default templateUrl => () => ({
  templateUrl,
  scope: true,
  link(scope, element, attr) {
    scope.line = scope.$line = scope.$eval(attr.line);
    scope.$ctrl = {
      ...scope.$ctrl,
      line: scope.line
    };
  }
});
